import axios from "axios";
import { translate } from "../i18n";

const api = axios.create({
  // Dev: no baseURL, package.json proxy routes to https://localhost:7211
  // Production: REACT_APP_API_URL=https://api.encrypt.avamboo.com
  baseURL: process.env.REACT_APP_API_URL || "",
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Formats an Axios error into a user-facing message.
 * In debug mode (REACT_APP_DEBUG_ERRORS=true), appends error code for diagnostics.
 * - If backend responded: uses backend message + HTTP status code (e.g. "(500)")
 * - If no response (network/connection): uses generic message + Axios error code (e.g. "(ERR_NETWORK)")
 *
 * @param {import("axios").AxiosError} error
 * @param {string} fallbackMessage - Shown when backend provides no message
 * @returns {string}
 */
export function formatApiError(error, fallbackMessage) {
  const debug = process.env.REACT_APP_DEBUG_ERRORS === "true";
  const translatedFallback = translate(fallbackMessage);

  if (error.response) {
    const status = error.response.status;
    const message = status < 500
      ? (error.response.data?.message || translatedFallback)
      : translatedFallback;
    if (!debug) return message;
    return `${message} (${status})`;
  } else {
    const code = error.code ?? "ERR_UNKNOWN";
    const message = translate("Keine Verbindung zum Server");
    if (!debug) return message;
    return `${message} (${code})`;
  }
}

export default api;
